// extracted by mini-css-extract-plugin
export var base = "box-module--base--328a2";
export var border = "box-module--border--f2143";
export var panelNormal = "box-module--panel-normal--bb0f2";
export var strong = "box-module--strong--98b65";